export function getAssignmentLabel(value) {
  if (!value) return '';
  if (value.startsWith('forwards')) {
    const [, lineIdx, pos] = value.split('-');
    const lineNum = parseInt(lineIdx, 10) + 1;
    const lineName = lineNum === 5 ? 'Extra FW' : `Forwards Line ${lineNum}`;
    return `${lineName} - ${pos}`;
  }
  if (value.startsWith('defensemen')) {
    const [, lineIdx, pos] = value.split('-');
    const lineNum = parseInt(lineIdx, 10) + 1;
    const lineName = lineNum === 4 ? 'Extra D' : `Defensemen Line ${lineNum}`;
    return `${lineName} - ${pos}`;
  }
  return '';
}

export function getAssignmentDisplayNumber(assignment) {
  if (!assignment) return '';
  if (assignment.startsWith('forwards')) {
    const [, lineIdx, pos] = assignment.split('-');
    const lineNum = parseInt(lineIdx, 10) + 1;
    if (lineNum === 5) {
      if (pos === 'LW') return 'Extra FW1';
      if (pos === 'C') return 'Extra FW2';
      if (pos === 'RW') return 'Extra FW3';
    }
    return `${pos}${lineNum}`;
  }
  if (assignment.startsWith('defensemen')) {
    const [, lineIdx, pos] = assignment.split('-');
    const lineNum = parseInt(lineIdx, 10) + 1;
    if (lineNum === 4) return `${pos}E`;
    return `${pos}${lineNum}`;
  }
  return '';
}

export function getGoalieAssignmentLabel(assignment) {
  if (!assignment) return '';
  return `Goalie ${assignment.replace('goalie', '')}`;
}

export function buildPlayerAssignmentMap(forwards, defensemen) {
  const map = new Map();
  forwards.forEach((line, lineIndex) => {
    Object.entries(line).forEach(([pos, player]) => {
      if (player) map.set(player.id, `forwards-${lineIndex}-${pos}`);
    });
  });
  defensemen.forEach((line, lineIndex) => {
    Object.entries(line).forEach(([pos, player]) => {
      if (player) map.set(player.id, `defensemen-${lineIndex}-${pos}`);
    });
  });
  return map;
}

export function buildGoalieAssignmentMap(lineupGoalies) {
  const map = new Map();
  lineupGoalies.forEach((goalie, index) => {
    if (goalie) map.set(goalie.id, `goalie${index + 1}`);
  });
  return map;
}
